module.exports = __webpack_public_path__ + "static/img/initiative3.c0f08fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/initiative3.png
// module id = A4ER
// module chunks = 1